
export class SolicitudBloqueoDTO {
  id: string;
  razonSocial: string;
  situacionExcedido: SituacionDTO;
  situacionVencido: SituacionDTO;
}

export class SituacionDTO {
  situacionAnterior: ConfiguracionComponenteBloqueo;
  situacionActual: ConfiguracionComponenteBloqueo;
  estado: EstadoSolicitudCliente;
}

export enum ConfiguracionComponenteBloqueo {
  SinConfiguracion = 0,
  NoBloquear = 1,
  NoBloquearDiasInhabiles = 2
}

export enum EstadoSolicitudCliente {
  Pendiente,
  Aprobada,
  Rechazada
}
